import React from 'react';
import { Badge } from 'reactstrap';

const RoleBadge = ({ role }) => {
  if (!role) {
    return null;
  }

  const colorMap = {
    'Owner': 'primary',
    'Admin': 'info',
    'Member': 'secondary',
  };

  const color = colorMap[role] || 'secondary';

  return (
    <Badge color={color} className="ms-2">
      {role}
    </Badge>
  );
};

export default RoleBadge;
